import React, { memo } from 'react';
import { getBeerPricing } from '../../api/fetchTaps';
import HappyHourBadge from '../HappyHourBadge/HappyHourBadge';
import './TapCard.css';

const TapCard = ({ beer, showHappyHour = true }) => {
  const pricing = getBeerPricing(beer);

  if (!beer) return null;

  // Format ABV display
  const formatAbv = (abv) => {
    if (!abv || abv === 0) return 'TBA';
    return `${abv}%`;
  };

  // Get style badge color
  const getStyleColor = (style) => {
    const colors = {
      'Hazy': '#f59e0b',
      'Pale Ale': '#10b981',
      'Lager': '#3b82f6',
      'Stout': '#8b5cf6',
      'Cider': '#ec4899',
      'TBA': '#6b7280'
    };
    return colors[style] || colors['TBA'];
  };

  // Truncate tasting notes to 2 lines
  const truncateNotes = (notes, maxLength = 120) => {
    if (!notes) return '';
    if (notes.length <= maxLength) return notes;
    return notes.substring(0, maxLength).trim() + '...';
  };

  return (
    <div className={`tap-card ${!beer.isAvailable ? 'tap-card--unavailable' : ''}`}>
      {/* Tap Number */}
      <div className="tap-card__number">
        <span className="tap-number">{beer.tapNumber}</span>
      </div>

      {/* Beer Info */}
      <div className="tap-card__header">
        <h3 className="beer-name">{beer.beerName}</h3>
        <p className="brewery-name">{beer.breweryName}</p>
        
        <div className="beer-meta">
          <span 
            className="beer-style"
            style={{ backgroundColor: getStyleColor(beer.style) }}
          >
            {beer.style}
          </span>
          <span className="beer-abv">{formatAbv(beer.abv)}</span>
        </div>
      </div>

      {/* Tasting Notes */}
      {beer.tastingNotes && (
        <div className="tap-card__description">
          <p className="tasting-notes">{truncateNotes(beer.tastingNotes)}</p>
        </div>
      )}

      {/* Pricing - Compact Display */}
      <div className="tap-card__pricing">
        {Object.entries(pricing).map(([size, info]) => (
          info.available && info.price ? (
            <div key={size} className="price-item-compact">
              <span className="price-label">{info.name}</span>
              <div className="price-info-compact">
                <span className="price">${info.price}</span>
                {showHappyHour && ['pot', 'schooner'].includes(size) && (
                  <HappyHourBadge size={size} show={true} />
                )}
              </div>
            </div>
          ) : null
        ))}
      </div>

      {/* Status */}
      {!beer.isAvailable && (
        <div className="tap-card__status">
          <span className="status-badge status-badge--unavailable">
            Coming Soon
          </span>
        </div>
      )}
    </div>
  );
};

export default memo(TapCard);